import { render, staticRenderFns } from "./BuildingDeviceImport.vue?vue&type=template&id=9b977a0e&scoped=true"
import script from "./BuildingDeviceImport.vue?vue&type=script&lang=js"
export * from "./BuildingDeviceImport.vue?vue&type=script&lang=js"
import style0 from "./BuildingDeviceImport.vue?vue&type=style&index=0&id=9b977a0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b977a0e",
  null
  
)

export default component.exports